import React from "react";
import { Link } from "react-router-dom";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";

const Partners = () => {
  const partnerCategories = [
    {
      title: "Banking & Financial Institutions",
      description: "We work with banks and NBFCs for co-lending, refinancing, and distribution of financial products to extend reach and offer competitive solutions.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
    },
    {
      title: "Channel & Distribution Partners",
      description: "Our network of agents, DSA partners, and distributors helps us serve customers across India with last-mile access to loans and financial services.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
    {
      title: "Technology & Platform Partners",
      description: "Strategic tie-ups with fintech platforms, aggregators, and tech providers enable us to offer digital-first, secure, and efficient lending experiences.",
      icon: (
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
    },
  ];

  const benefits = [
    "Access to RBI-registered NBFC products and compliant processes",
    "Transparent commission and settlement structures",
    "Dedicated partner support and training",
    "Technology integration and API support where applicable",
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f9fa] to-white" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
      <PageBanner
        title="Our Partners"
        subtitle="Building trust through strategic partnerships for financial inclusion"
      />

      {/* Intro */}
      <ScrollReveal variant="fadeUp">
      <section className="max-w-5xl mx-auto px-6 lg:px-12 py-10 md:py-14">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] mb-4 tracking-tight">
            Partner With Pawansut Holdings
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
            As an RBI-registered NBFC with over four decades of experience, we believe in growing together. Our partners benefit from our robust product suite, compliance framework, and pan-India reach to serve more customers responsibly.
          </p>
        </div>

        {/* Partner categories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-14">
          {partnerCategories.map((cat, i) => (
            <div
              key={i}
              className="bg-white rounded-xl shadow-md border border-gray-100 p-6 hover:shadow-lg transition-shadow duration-200"
            >
              <div className="text-[#1565c0] mb-4">{cat.icon}</div>
              <h3 className="text-lg font-semibold text-[#1a1a1a] mb-3">{cat.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{cat.description}</p>
            </div>
          ))}
        </div>

        {/* Why partner with us */}
        <div className="bg-[#1a1a1a] text-white rounded-2xl p-8 md:p-10 mb-12">
          <h3 className="text-xl md:text-2xl font-bold mb-6 text-center">Why Partner With Us</h3>
          <ul className="space-y-3 max-w-2xl mx-auto">
            {benefits.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="text-[#00BFAE] mt-0.5 shrink-0">✓</span>
                <span className="text-gray-200">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-gray-600 mb-6">
            Interested in becoming a partner? We’d love to hear from you.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#1a1a1a] text-white px-8 py-3 rounded-lg font-semibold no-underline hover:bg-gray-800 transition-colors"
          >
            Get in Touch
          </Link>
        </div>
      </section>
      </ScrollReveal>
    </div>
  );
};

export default Partners;
